<template>
  <div id="privacy">
    <section id="privacy-policy">
      <div class="title">
        <div class="en">
          <span>Privacy Policy</span>
        </div>
        <div class="jp">
          <span>プライバシーポリシー</span>
        </div>
      </div>
      <div v-if="confOkFlag" class="return-contact">
        <router-link :to="{ name: 'contact', params: {
            value: 'contact',
            from: 'privacy',
            confOkFlag: confOkFlag,
            contentOfInquiry: contentOfInquiry,
            companyName: companyName,
            name: name,
            age: age,
            mail: mail,
            message: message
          }}">同意してお問い合わせに戻る</router-link>
      </div>
      <div class="content">
        <h3>当社について</h3>
        <ol class="list-style-type-none">
          <li>当社は「株式会社ビットハイブ」といいます。当社のコーポレートサイトのアドレスは「bithive.co.jp」です。</li>
        </ol>
        <h3>当社の個人情報保護管理者</h3>
        <ol class="list-style-type-none">
          <li>浅原 孝経</li>
        </ol>
        <h3>個人情報の利用目的</h3>
        <ol>
          <li>お客様ならびにパートナー企業様との業務に関わるお問い合わせ、連絡、契約履行に必要な書類作成等で利用します。</li>
          <li>当社が実施するセミナーのご案内、アンケートのご依頼等で利用します。</li>
          <li>当社が実施する採用選考や入社手続き、入社後の雇用に関わる業務および福利厚生の手続き等で利用します。</li>
        </ol>
        <h3>個人情報の第三者提供について</h3>
        <ol class="list-style-type-none">
          <li>当社で取得した個人情報は、警察より刑事訴訟法第197条の規定に基づく報告の求めに応じるよう要請された場合、弁護士より弁護士法第23条の2第2項の規定に基づく弁護士会からの報告の求めに応じるよう要請された場合を除き、ご本人様の承諾無しに第三者へ提供をいたしません。</li>
        </ol>
        <h3>個人情報の取り扱いの委託について</h3>
        <ol class="list-style-type-none">
          <li>当社で取得した個人情報の全部又は、一部を委託することはいたしません。</li>
        </ol>
        <h3>個人情報の開示等の請求手続きについて</h3>
        <ol class="list-style-type-none">
          <li>当社は個人情報保護法の趣旨に則り、当社が保有する個人情報のご本人またはその代理人からの以下の請求（以下、総称して「開示等のご請求」といいます）に対応いたします。</li>
        </ol>
        <ol>
          <li>保有個人データの開示のご請求</li>
          <li>保有個人データの利用目的の通知のご請求</li>
          <li>保有個人データの内容の訂正、追加、または削除のご請求</li>
          <li>保有個人データの利用停止もしくは消去、第三者提供の停止のご請求</li>
        </ol>
        <ol class="list-style-type-none">
          <li>なお、当社が対応させていただく際の手続きは、下記の通りです。</li>
          <li>
            <ol>
              <li>
                開示等のご請求の申し出先
                <div>
                  <span>〒101-0052</span>
                  <span class="br">東京都千代田区神田小川町1-9 川上ビル3F</span>
                  <span class="br">株式会社ビットハイブ</span>
                  <span class="br">浅原 孝経 宛</span>
                </div>
              </li>
              <li>
                ご請求書の内容について
                <span class="br">ご請求書の内容に必要な下記の事項をご記載ください。</span>
                <ol>
                  <li>ご請求書作成年月日</li>
                  <li>請求者の住所、氏名、ご連絡先</li>
                  <li>対象の個人情報に該当する個人の住所、氏名、ご連絡先</li>
                  <li>請求内容</li>
                </ol>
              </li>
              <li>
                必要書類について
                <ol>
                  <li>運転免許証、パスポート等の写真で本人確認ができるものの写し（開示等の求めをする本人の名前および住所が記載されているもの）</li>
                  <li>住民票の写し（開示等の求めをする日前30日以内に作成されたもの）</li>
                  <li>代理人がご請求される場合は、代理人を証明する書類、代理人の運転免許証、パスポート等の写真で代理人確認ができるものの写し（開示等の求めをする代理人の名前および住所が記載されているもの）</li>
                  <li>代理人がご請求される場合は、代理人の住民票の写し（開示等の求めをする日前30日以内に作成されたもの）</li>
                  <li>代理人がご請求される場合は、代理の旨が記載されたご本人様からの委任状</li>
                  <li>代理人が弁護士の場合は、登録番号がわかる書類</li>
                </ol>
              </li>
              <li>
                開示等のご請求に関する手数料
                <span class="br">保有個人データの開示または利用目的の通知のご請求の場合は、1回の請求ごとに540円となります（請求書類とともに、540円分の郵便切手を同封してお送りください）。訂正、追加、削除、利用停止、消去、第三者提供の停止のご請求の場合は、手数料はいただきません。なお、全てのご請求の場合において、請求書類を当社へお送りいただく際の郵送料は、請求者様にてご負担ください。</span>
              </li>
              <li>
                ご請求に対する回答方法
                <span class="br">請求書記載の住所宛に、書留郵便にて回答いたします。</span>
              </li>
              <li>
                ご請求に関して取得した個人情報の取り扱いについて
                <span class="br">開示等のご請求にともなって取得した個人情報は、開示等のご請求への対応に必要な範囲でのみ取り扱うものとします。提出いただいた書類の返却はいたしかねます。</span>
              </li>
              <li>
                保有個人データの不開示事由について
                <span class="br">以下のいずれかに該当する場合は、開示等に対応することができませんが、その旨、理由を付記してご通知いたします（お送りいただいた手数料の返還はいたしかねますので、ご了承ください）。</span>
                <ol>
                  <li>本人が確認できない場合</li>
                  <li>代理権が確認できない場合</li>
                  <li>代理人が確認できない場合</li>
                  <li>書類に不備がある場合</li>
                  <li>請求書に記載された内容で、当社が保有個人データを特定できなかった場合</li>
                  <li>必要な手数料のお支払いがない、またお支払い額が不足している場合</li>
                  <li>開示の求めの対象が保有個人データの範囲でない場合</li>
                  <li>本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
                  <li>当社業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
                  <li>法令に違反することとなる場合</li>
                </ol>
              </li>
              <li>
                その他注意事項について
                <ol>
                  <li>保有個人データの利用停止もしくは消去、第三者提供の停止のご請求の結果、このような保有個人データに対するサービス等はご利用いただけなくなりますので、ご了承ください。</li>
                  <li>ご請求の内容によっては回答にお時間をいただく場合がございます。</li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
        <h3>本人が容易に認識できない方法による個人情報の取得について</h3>
        <ol class="list-style-type-none">
          <li>当社ではCookieやウェブビーコン等を用いるなどして、本人が容易に認識できない方法による個人情報の取得は行っておりません。</li>
        </ol>
        <h3>個人情報の取扱に関する苦情、相談の問い合わせ先について</h3>
        <ol class="list-style-type-none">
          <li>
            下記の窓口までお問い合わせください。
            <div>
              <span>〒101-0052</span>
              <span class="br">東京都千代田区神田小川町1-9 川上ビル3F</span>
              <span class="br">株式会社ビットハイブ</span>
              <span class="br">浅原 孝経 宛</span>
              <span class="br">TEL: 03-6811-7716</span>
            </div>
          </li>
        </ol>
        <h3>見直しについて</h3>
        <ol class="list-style-type-none">
          <li>当社では、個人情報の取扱について適用される日本の法令に従って、個人情報を適切に取扱うため、本ページの内容について、適宜見直しを行ってまいります。開示等のご請求の際は、その都度、最新の内容をご確認のうえお手続きくださるようお願いします。</li>
        </ol>
      </div>
      <div class="last">
        <span>以上</span>
      </div>
      <div v-if="confOkFlag" class="return-contact">
        <router-link :to="{ name: 'contact', params: {
            value: 'contact',
            from: 'privacy',
            confOkFlag: confOkFlag,
            contentOfInquiry: contentOfInquiry,
            companyName: companyName,
            name: name,
            age: age,
            mail: mail,
            message: message
          }}">同意してお問い合わせに戻る</router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  data () {
    return {
      confOkFlag: false,
      contentOfInquiry: '0',
      companyName: '',
      name: '',
      age: '',
      mail: '',
      message: ''
    }
  },
  mounted () {
    if (this.$route.params.value != null) {
      document.getElementById(this.$route.params.value).scrollIntoView()
      window.scrollBy(0, -58)
    }
    if (this.$route.params.confOkFlag === true) {
      this.confOkFlag = true
    }
    if (this.$route.params.contentOfInquiry != null) {
      this.contentOfInquiry = this.$route.params.contentOfInquiry
    }
    if (this.$route.params.companyName != null) {
      this.companyName = this.$route.params.companyName
    }
    if (this.$route.params.name != null) {
      this.name = this.$route.params.name
    }
    if (this.$route.params.age != null) {
      this.age = this.$route.params.age
    }
    if (this.$route.params.mail != null) {
      this.mail = this.$route.params.mail
    }
    if (this.$route.params.message != null) {
      this.message = this.$route.params.message
    }
  }
}
</script>

<style lang="scss">
@import "../assets/style/global.scss";

#privacy {
  > #privacy-policy {
    @media screen and (max-width: 1024px) {
      padding: 37px 20px;
    }
    @media screen and (min-width: 1025px) {
      padding: 37px 70px;
    }
    > .title {
      margin: 0 0 37px;
      > .en {
        font-weight: 700;
        font-size: 28px;
      }
      > .jp {
        font-size: 11px;
      }
    }
    > .return-contact {
      margin: 30px 0;
      > a {
        text-decoration: none;
        color: cornflowerblue;
      }
      > a:hover {
        opacity: .6;
      }
    }
    > .content {
      text-align: justify;
      line-height: 30px;
      > h3 {
        border-left-style: solid;
        font-size: 18px;
        margin-bottom: 27px;
        line-height: 1.5;
        font-weight: 700;
        padding: 0 0 0 15px;
      }
      > ol {
        padding-inline-start: 30px;
      }
      > ol > li {
        padding: 0 0 13px 5px;
        @media screen and (max-width: 1024px) {
          font-size: 14px !important;
        }
        @media screen and (min-width: 1025px) {
          font-size: 16px !important;
        }
      }
      > ol > li > ol {
        list-style-type: upper-latin;
        padding-inline-start: 30px;
        > li {
          margin: 15px 0;
        }
      }
      > ol > li > div, ol > li > ol > li > div {
        padding: 15px 5px;
        font-weight: 700;
        line-height: 1.5em;
      }
      > ol > li > ol > li > ol {
        list-style-type: katakana;
        > li {
          margin: 15px 0;
        }
      }
      > ol.list-style-type-none {
        padding-inline-start: 0;
        list-style-type: none;
      }
    }
    > .last {
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue